import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from './use-api-client.js';

// Improvement proposals for aidev from the server's sessions (ADR-025)

export function useImprovements(serverId: string) {
  const api = useApiClient();
  return useQuery({
    queryKey: ['improvements', serverId],
    queryFn: () => api.outbox.improvements(serverId),
    select: (d) => d.improvements,
    refetchInterval: 60_000,
    refetchOnWindowFocus: 'always',
  });
}

export function useDecideImprovement(serverId: string) {
  const api = useApiClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (v: { id: string; decision: 'open' | 'dismiss'; edits?: { title?: string; body?: string; duplicateOf?: number } }) =>
      v.decision === 'open' ? api.outbox.open(serverId, v.id, v.edits ?? {}) : api.outbox.dismiss(serverId, v.id),
    onSettled: () => {
      void qc.invalidateQueries({ queryKey: ['improvements', serverId] });
      void qc.invalidateQueries({ queryKey: ['inbox', serverId] });
    },
  });
}

/** Open aidev issues, offered as the one to keep when a proposal is a duplicate; fetched only while reviewing */
export function useAidevIssues(serverId: string, enabled: boolean) {
  const api = useApiClient();
  return useQuery({
    queryKey: ['aidev-issues', serverId],
    queryFn: () => api.outbox.issues(serverId),
    select: (d) => d.issues,
    enabled,
    staleTime: 60_000,
  });
}
